import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useAPIGetPelaksanaanPerilakuKerjaPS } from 'api/kinerja/pengawas-sekolah/pelaksanaan'
import { useAPIGetPerencanaan } from 'api/kinerja/pengawas-sekolah/perencanaan'

import type { TPelaksanaanPerilakuKerja } from 'types/kinerja-ps-pegawai'

type TUsePelaksanaanPSHooks = {
  pelaksanaan: TPelaksanaanPerilakuKerja
  apiStatus: string
}

export const usePelaksanaanPerilakuKerjaPS = (): TUsePelaksanaanPSHooks => {
  const { period, isHavePeriod } = usePeriodContext()
  const { data: perencanaan } = useAPIGetPerencanaan({
    periodId: period.id,
    enabled: isHavePeriod,
  })
  const { data: pelaksanaan, status: apiStatus } =
    useAPIGetPelaksanaanPerilakuKerjaPS({
      skpPsId: perencanaan?.skpPsId,
      enabled: !!perencanaan?.skpPsId && isHavePeriod,
    })

  return {
    pelaksanaan,
    apiStatus,
  }
}
